export const CustomerSupportAnimation = {
  nm: "05",
  h: 281,
  w: 281,
  meta: { g: "LottieFiles Figma v91" },
  layers: [
    {
      ty: 4,
      nm: "Subtract",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [62.3, 44.77],
              t: 0,
            },
            { s: [74.8, 53.8], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [140, 94.77],
              t: 0,
            },
            { s: [139.8, 89.8], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -34.863],
                      [3.651, -8.032],
                      [0, 0],
                      [0, 9.453],
                      [33.288, 0],
                      [0, -33.784],
                      [-3.775, -7.989],
                      [0, 0],
                      [0, 9.421],
                      [-34.419, 0],
                    ],
                    o: [
                      [34.419, 0],
                      [0, 9.421],
                      [0, 0],
                      [3.775, -7.989],
                      [0, -33.784],
                      [-33.288, 0],
                      [0, 9.453],
                      [0, 0],
                      [-3.65, -8.032],
                      [0, -34.863],
                      [0, 0],
                    ],
                    v: [
                      [62.297, 0],
                      [124.595, 63.148],
                      [118.907, 89.541],
                      [116.704, 89.541],
                      [122.595, 63.148],
                      [62.297, 2],
                      [2, 63.148],
                      [7.89, 89.541],
                      [5.687, 89.541],
                      [0, 63.148],
                      [62.297, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -41.86],
                      [4.41, -9.67],
                      [0, 0],
                      [0, 11.38],
                      [40.19, 0],
                      [0, -40.78],
                      [-4.53, -9.62],
                      [0, 0],
                      [0, 11.34],
                      [-41.32, 0],
                    ],
                    o: [
                      [41.32, 0],
                      [0, 11.34],
                      [0, 0],
                      [4.53, -9.62],
                      [0, -40.78],
                      [-40.19, 0],
                      [0, 11.38],
                      [0, 0],
                      [-4.41, -9.67],
                      [0, -41.86],
                      [0, 0],
                    ],
                    v: [
                      [74.8, 0],
                      [149.59, 75.82],
                      [142.73, 107.59],
                      [140.52, 107.59],
                      [147.59, 75.82],
                      [74.8, 2],
                      [2, 75.82],
                      [9.07, 107.59],
                      [6.87, 107.59],
                      [0, 75.82],
                      [74.8, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 1,
    },
    {
      ty: 4,
      nm: "Vector",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [36, 18] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [140, 152.82] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-19.882, 0],
                      [0, -19.882],
                      [0, 0],
                    ],
                    o: [
                      [0, -19.882],
                      [19.882, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 36],
                      [36, 0],
                      [72, 36],
                      [0, 36],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-19.88, 0],
                      [0, -19.88],
                      [0, 0],
                    ],
                    o: [
                      [0, -19.88],
                      [19.88, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 36],
                      [36, 0],
                      [72, 36],
                      [0, 36],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "st",
          nm: "",
          lc: 1,
          lj: 2,
          ml: 4,
          o: { a: 0, k: 100 },
          w: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [2], t: 0 },
              { s: [2], t: 75 },
            ],
          },
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
        },
      ],
      ind: 2,
    },
    {
      ty: 4,
      nm: "Subtract",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [22.49, 16.02],
              t: 0,
            },
            { s: [39.02, 27.96], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [140, 105.34],
              t: 0,
            },
            { s: [139.8, 102.32], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -12.571],
                      [1.242, -2.828],
                      [0, 0],
                      [0, 3.325],
                      [11.301, 0],
                      [0, -11.492],
                      [-1.367, -2.785],
                      [0, 0],
                      [0, 3.292],
                      [-12.432, 0],
                    ],
                    o: [
                      [12.432, 0],
                      [0, 3.292],
                      [0, 0],
                      [1.367, -2.785],
                      [0, -11.492],
                      [-11.301, 0],
                      [0, 3.325],
                      [0, 0],
                      [-1.241, -2.828],
                      [0, -12.571],
                      [0, 0],
                    ],
                    v: [
                      [22.486, 0],
                      [44.973, 22.785],
                      [43.04, 32.035],
                      [40.836, 32.035],
                      [42.973, 22.785],
                      [22.486, 2],
                      [2, 22.785],
                      [4.137, 32.035],
                      [1.933, 32.035],
                      [0, 22.785],
                      [22.486, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -21.83],
                      [2.24, -4.99],
                      [0, 0],
                      [0, 5.87],
                      [20.43, 0],
                      [0, -20.75],
                      [-2.37, -4.95],
                      [0, 0],
                      [0, 5.84],
                      [-21.56, 0],
                    ],
                    o: [
                      [21.56, 0],
                      [0, 5.84],
                      [0, 0],
                      [2.37, -4.95],
                      [0, -20.75],
                      [-20.43, 0],
                      [0, 5.87],
                      [0, 0],
                      [-2.24, -4.99],
                      [0, -21.83],
                      [0, 0],
                    ],
                    v: [
                      [39.02, 0],
                      [78.04, 39.55],
                      [74.55, 55.92],
                      [72.35, 55.92],
                      [76.04, 39.55],
                      [39.02, 2],
                      [2, 39.55],
                      [5.69, 55.92],
                      [3.49, 55.92],
                      [0, 39.55],
                      [39.02, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: {
            a: 1,
            k: [
              { o: { x: 0, y: 0.66 }, i: { x: 0.66, y: 1 }, s: [0], t: 0 },
              { s: [100], t: 75 },
            ],
          },
        },
      ],
      ind: 3,
    },
    {
      ty: 4,
      nm: "Vector (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [23, 23.5] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [140, 112.32] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.77, 0],
                      [0.751, 0.076],
                      [0, 0],
                      [-0.703, 0],
                      [-0.684, 0.069],
                      [0, 0],
                    ],
                    o: [
                      [-0.751, 0.076],
                      [-0.77, 0],
                      [0, 0],
                      [0.684, 0.069],
                      [0.703, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [25.281, 46.886],
                      [23, 47],
                      [20.719, 46.886],
                      [20.919, 44.896],
                      [23, 45],
                      [25.081, 44.896],
                      [25.281, 46.886],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.77, 0],
                      [0.75, 0.08],
                      [0, 0],
                      [-0.7, 0],
                      [-0.68, 0.07],
                      [0, 0],
                    ],
                    o: [
                      [-0.75, 0.08],
                      [-0.77, 0],
                      [0, 0],
                      [0.68, 0.07],
                      [0.7, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [25.28, 46.89],
                      [23, 47],
                      [20.72, 46.89],
                      [20.92, 44.9],
                      [23, 45],
                      [25.08, 44.9],
                      [25.28, 46.89],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-1.336, -0.419],
                      [0, 0],
                      [0, 0],
                      [1.325, 0.734],
                      [0, 0],
                    ],
                    o: [
                      [1.208, 0.669],
                      [0, 0],
                      [0, 0],
                      [-1.466, -0.459],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.021, 42.422],
                      [16.845, 44.062],
                      [16.545, 45.016],
                      [16.246, 45.971],
                      [12.052, 44.172],
                      [13.021, 42.422],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-1.34, -0.42],
                      [0, 0],
                      [0, 0],
                      [1.32, 0.73],
                      [0, 0],
                    ],
                    o: [
                      [1.21, 0.67],
                      [0, 0],
                      [0, 0],
                      [-1.47, -0.46],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.02, 42.42],
                      [16.84, 44.06],
                      [16.54, 45.02],
                      [16.25, 45.97],
                      [12.05, 44.17],
                      [13.02, 42.42],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [1.466, -0.459],
                      [0, 0],
                      [0, 0],
                      [-1.208, 0.669],
                      [0, 0],
                    ],
                    o: [
                      [-1.325, 0.734],
                      [0, 0],
                      [0, 0],
                      [1.336, -0.419],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.948, 44.172],
                      [29.754, 45.971],
                      [29.455, 45.016],
                      [29.155, 44.062],
                      [32.98, 42.422],
                      [33.948, 44.172],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [1.47, -0.46],
                      [0, 0],
                      [0, 0],
                      [-1.21, 0.67],
                      [0, 0],
                    ],
                    o: [
                      [-1.32, 0.73],
                      [0, 0],
                      [0, 0],
                      [1.34, -0.42],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.95, 44.17],
                      [29.75, 45.97],
                      [29.46, 45.02],
                      [29.16, 44.06],
                      [32.98, 42.42],
                      [33.95, 44.17],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-1.058, -0.899],
                      [0, 0],
                      [0.949, 1.194],
                      [0, 0],
                    ],
                    o: [
                      [0.868, 1.093],
                      [0, 0],
                      [-1.158, -0.984],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [6.699, 37.057],
                      [9.597, 40.052],
                      [8.302, 41.576],
                      [5.134, 38.301],
                      [6.699, 37.057],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-1.06, -0.9],
                      [0, 0],
                      [0.95, 1.19],
                      [0, 0],
                    ],
                    o: [
                      [0.87, 1.09],
                      [0, 0],
                      [-1.16, -0.98],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [6.7, 37.06],
                      [9.6, 40.05],
                      [8.3, 41.58],
                      [5.13, 38.3],
                      [6.7, 37.06],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [1.158, -0.984],
                      [0, 0],
                      [-0.868, 1.093],
                      [0, 0],
                    ],
                    o: [
                      [-0.949, 1.194],
                      [0, 0],
                      [1.058, -0.899],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [40.866, 38.301],
                      [37.698, 41.576],
                      [36.403, 40.052],
                      [39.301, 37.057],
                      [40.866, 38.301],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [1.16, -0.98],
                      [0, 0],
                      [-0.87, 1.09],
                      [0, 0],
                    ],
                    o: [
                      [-0.95, 1.19],
                      [0, 0],
                      [1.06, -0.9],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [40.87, 38.3],
                      [37.7, 41.58],
                      [36.4, 40.05],
                      [39.3, 37.06],
                      [40.87, 38.3],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.634, -1.225],
                      [0, 0],
                      [0.432, 1.475],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0.396, 1.351],
                      [0, 0],
                      [-0.693, -1.338],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.882, 29.687],
                      [4.434, 33.557],
                      [2.658, 34.477],
                      [0.963, 30.248],
                      [1.922, 29.967],
                      [2.882, 29.687],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.63, -1.22],
                      [0, 0],
                      [0.43, 1.48],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0.4, 1.35],
                      [0, 0],
                      [-0.69, -1.34],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.88, 29.69],
                      [4.43, 33.56],
                      [2.66, 34.48],
                      [0.96, 30.25],
                      [1.92, 29.97],
                      [2.88, 29.69],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.693, -1.338],
                      [0, 0],
                      [-0.396, 1.351],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.432, 1.475],
                      [0, 0],
                      [0.634, -1.225],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [44.078, 29.967],
                      [45.037, 30.248],
                      [43.342, 34.477],
                      [41.566, 33.557],
                      [43.118, 29.687],
                      [44.078, 29.967],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.69, -1.34],
                      [0, 0],
                      [-0.4, 1.35],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.43, 1.48],
                      [0, 0],
                      [0.63, -1.22],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [44.08, 29.97],
                      [45.04, 30.25],
                      [43.34, 34.48],
                      [41.57, 33.56],
                      [43.12, 29.69],
                      [44.08, 29.97],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.07, 0.749],
                      [0, 0],
                      [0, -0.705],
                      [-0.065, -0.687],
                      [0, 0],
                      [0, 0.767],
                    ],
                    o: [
                      [0, -0.767],
                      [0, 0],
                      [-0.065, 0.687],
                      [0, 0.705],
                      [0, 0],
                      [-0.07, -0.749],
                      [0, 0],
                    ],
                    v: [
                      [0, 23.5],
                      [0.106, 21.225],
                      [2.098, 21.411],
                      [2, 23.5],
                      [2.098, 25.589],
                      [0.106, 25.775],
                      [0, 23.5],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.07, 0.75],
                      [0, 0],
                      [0, -0.7],
                      [-0.06, -0.69],
                      [0, 0],
                      [0, 0.77],
                    ],
                    o: [
                      [0, -0.77],
                      [0, 0],
                      [-0.06, 0.69],
                      [0, 0.7],
                      [0, 0],
                      [-0.07, -0.75],
                      [0, 0],
                    ],
                    v: [
                      [0, 23.5],
                      [0.11, 21.22],
                      [2.1, 21.41],
                      [2, 23.5],
                      [2.1, 25.59],
                      [0.11, 25.78],
                      [0, 23.5],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.065, 0.687],
                      [0, 0],
                      [0, -0.767],
                      [0.07, -0.749],
                      [0, 0],
                      [0, 0.705],
                    ],
                    o: [
                      [0, -0.705],
                      [0, 0],
                      [0.07, 0.749],
                      [0, 0.767],
                      [0, 0],
                      [0.065, -0.687],
                      [0, 0],
                    ],
                    v: [
                      [44, 23.5],
                      [43.902, 21.411],
                      [45.894, 21.225],
                      [46, 23.5],
                      [45.894, 25.775],
                      [43.902, 25.589],
                      [44, 23.5],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.06, 0.69],
                      [0, 0],
                      [0, -0.77],
                      [0.07, -0.75],
                      [0, 0],
                      [0, 0.7],
                    ],
                    o: [
                      [0, -0.7],
                      [0, 0],
                      [0.07, 0.75],
                      [0, 0.77],
                      [0, 0],
                      [0.06, -0.69],
                      [0, 0],
                    ],
                    v: [
                      [44, 23.5],
                      [43.9, 21.41],
                      [45.89, 21.22],
                      [46, 23.5],
                      [45.89, 25.78],
                      [43.9, 25.59],
                      [44, 23.5],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.396, -1.351],
                      [0, 0],
                      [0, 0],
                      [-0.693, 1.338],
                      [0, 0],
                    ],
                    o: [
                      [-0.634, 1.224],
                      [0, 0],
                      [0, 0],
                      [0.432, -1.475],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4.434, 13.443],
                      [2.882, 17.314],
                      [1.922, 17.033],
                      [0.963, 16.752],
                      [2.658, 12.523],
                      [4.434, 13.443],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.4, -1.35],
                      [0, 0],
                      [0, 0],
                      [-0.69, 1.34],
                      [0, 0],
                    ],
                    o: [
                      [-0.63, 1.22],
                      [0, 0],
                      [0, 0],
                      [0.43, -1.48],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4.43, 13.44],
                      [2.88, 17.31],
                      [1.92, 17.03],
                      [0.96, 16.75],
                      [2.66, 12.52],
                      [4.43, 13.44],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.432, -1.475],
                      [0, 0],
                      [0, 0],
                      [0.634, 1.224],
                      [0, 0],
                    ],
                    o: [
                      [0.693, 1.338],
                      [0, 0],
                      [0, 0],
                      [-0.396, -1.351],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [43.342, 12.523],
                      [45.037, 16.752],
                      [44.078, 17.033],
                      [43.118, 17.314],
                      [41.566, 13.443],
                      [43.342, 12.523],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.43, -1.48],
                      [0, 0],
                      [0, 0],
                      [0.63, 1.22],
                      [0, 0],
                    ],
                    o: [
                      [0.69, 1.34],
                      [0, 0],
                      [0, 0],
                      [-0.4, -1.35],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [43.34, 12.52],
                      [45.04, 16.75],
                      [44.08, 17.03],
                      [43.12, 17.31],
                      [41.57, 13.44],
                      [43.34, 12.52],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.868, -1.093],
                      [0, 0],
                      [-1.158, 0.984],
                      [0, 0],
                    ],
                    o: [
                      [-1.058, 0.899],
                      [0, 0],
                      [0.949, -1.194],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.597, 6.948],
                      [6.699, 9.943],
                      [5.134, 8.699],
                      [8.302, 5.424],
                      [9.597, 6.948],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.87, -1.09],
                      [0, 0],
                      [-1.16, 0.98],
                      [0, 0],
                    ],
                    o: [
                      [-1.06, 0.9],
                      [0, 0],
                      [0.95, -1.19],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.6, 6.95],
                      [6.7, 9.94],
                      [5.13, 8.7],
                      [8.3, 5.42],
                      [9.6, 6.95],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.949, -1.194],
                      [0, 0],
                      [1.058, 0.899],
                      [0, 0],
                    ],
                    o: [
                      [1.158, 0.984],
                      [0, 0],
                      [-0.868, -1.093],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [37.698, 5.424],
                      [40.866, 8.699],
                      [39.301, 9.943],
                      [36.403, 6.948],
                      [37.698, 5.424],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.95, -1.19],
                      [0, 0],
                      [1.06, 0.9],
                      [0, 0],
                    ],
                    o: [
                      [1.16, 0.98],
                      [0, 0],
                      [-0.87, -1.09],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [37.7, 5.42],
                      [40.87, 8.7],
                      [39.3, 9.94],
                      [36.4, 6.95],
                      [37.7, 5.42],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [1.208, -0.669],
                      [0, 0],
                      [-1.466, 0.46],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-1.336, 0.419],
                      [0, 0],
                      [1.325, -0.734],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.545, 1.984],
                      [16.845, 2.938],
                      [13.021, 4.578],
                      [12.052, 2.828],
                      [16.246, 1.029],
                      [16.545, 1.984],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [1.21, -0.67],
                      [0, 0],
                      [-1.47, 0.46],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-1.34, 0.42],
                      [0, 0],
                      [1.32, -0.73],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.54, 1.98],
                      [16.84, 2.94],
                      [13.02, 4.58],
                      [12.05, 2.83],
                      [16.25, 1.03],
                      [16.54, 1.98],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-1.325, -0.734],
                      [0, 0],
                      [1.336, 0.419],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [1.466, 0.46],
                      [0, 0],
                      [-1.208, -0.669],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [29.754, 1.029],
                      [33.948, 2.828],
                      [32.98, 4.578],
                      [29.155, 2.938],
                      [29.455, 1.984],
                      [29.754, 1.029],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-1.32, -0.73],
                      [0, 0],
                      [1.34, 0.42],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [1.47, 0.46],
                      [0, 0],
                      [-1.21, -0.67],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [29.75, 1.03],
                      [33.95, 2.83],
                      [32.98, 4.58],
                      [29.16, 2.94],
                      [29.46, 1.98],
                      [29.75, 1.03],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.751, -0.076],
                      [0, 0],
                      [0.703, 0],
                      [0.684, -0.069],
                      [0, 0],
                      [-0.77, 0],
                    ],
                    o: [
                      [0.77, 0],
                      [0, 0],
                      [-0.684, -0.069],
                      [-0.703, 0],
                      [0, 0],
                      [0.751, -0.076],
                      [0, 0],
                    ],
                    v: [
                      [23, 0],
                      [25.281, 0.114],
                      [25.081, 2.104],
                      [23, 2],
                      [20.919, 2.104],
                      [20.719, 0.114],
                      [23, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.75, -0.08],
                      [0, 0],
                      [0.7, 0],
                      [0.68, -0.07],
                      [0, 0],
                      [-0.77, 0],
                    ],
                    o: [
                      [0.77, 0],
                      [0, 0],
                      [-0.68, -0.07],
                      [-0.7, 0],
                      [0, 0],
                      [0.75, -0.08],
                      [0, 0],
                    ],
                    v: [
                      [23, 0],
                      [25.28, 0.11],
                      [25.08, 2.1],
                      [23, 2],
                      [20.92, 2.1],
                      [20.72, 0.11],
                      [23, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 4,
    },
    {
      ty: 4,
      nm: "Subtract",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [42.84, 30.72],
              t: 0,
            },
            { s: [58.13, 41.83], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [140, 101.58],
              t: 0,
            },
            { s: [139.8, 98], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -23.966],
                      [2.472, -5.488],
                      [0, 0],
                      [0, 6.457],
                      [22.541, 0],
                      [0, -22.888],
                      [-2.597, -5.445],
                      [0, 0],
                      [0, 6.425],
                      [-23.672, 0],
                    ],
                    o: [
                      [23.672, 0],
                      [0, 6.425],
                      [0, 0],
                      [2.597, -5.445],
                      [0, -22.888],
                      [-22.541, 0],
                      [0, 6.457],
                      [0, 0],
                      [-2.472, -5.488],
                      [0, -23.966],
                      [0, 0],
                    ],
                    v: [
                      [42.838, 0],
                      [85.676, 43.419],
                      [81.824, 61.432],
                      [79.622, 61.432],
                      [83.676, 43.419],
                      [42.838, 2],
                      [2, 43.419],
                      [6.054, 61.432],
                      [3.852, 61.432],
                      [0, 43.419],
                      [42.838, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, -32.58],
                      [3.4, -7.5],
                      [0, 0],
                      [0, 8.83],
                      [30.99, 0],
                      [0, -31.5],
                      [-3.52, -7.46],
                      [0, 0],
                      [0, 8.79],
                      [-32.12, 0],
                    ],
                    o: [
                      [32.12, 0],
                      [0, 8.79],
                      [0, 0],
                      [3.52, -7.46],
                      [0, -31.5],
                      [-30.99, 0],
                      [0, 8.83],
                      [0, 0],
                      [-3.4, -7.5],
                      [0, -32.58],
                      [0, 0],
                    ],
                    v: [
                      [58.13, 0],
                      [116.26, 59.02],
                      [110.97, 83.65],
                      [108.76, 83.65],
                      [114.26, 59.02],
                      [58.13, 2],
                      [2, 59.02],
                      [7.5, 83.65],
                      [5.29, 83.65],
                      [0, 59.02],
                      [58.13, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 5,
    },
  ],
  v: "5.7.0",
  fr: 60,
  op: 75.01,
  ip: 0,
  assets: [],
};
